import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Form, Row, Col, Button, Table, Card } from 'react-bootstrap';
import Select from 'react-select';
import { BASE_URL } from '../../services/Api';
import { authHeader } from '../../services/auth-header';
import { debounce } from 'lodash';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { FaArrowLeft, FaTrashAlt } from 'react-icons/fa';

const ProductionOrderUpdate = () => {
  const { id, pointindex } = useParams();
  const navigate = useNavigate();
  const [type, settype] = useState('');
  const [jobnumber, setjobnumber] = useState('');
  const [partno, setpartno] = useState('');

  const [customerOptions, setCustomerOptions] = useState([]);
  const [staffOptions, setStaffOptions] = useState([]);
  const [billOfMaterialOptions, setBillOfMaterialOptions] = useState([]);
  const [customerSearch, setCustomerSearch] = useState(encodeURIComponent(" "));
  const [staffSearch, setStaffSearch] = useState(encodeURIComponent(" "));
  const [billOfMaterialSearch, setBillOfMaterialSearch] = useState(encodeURIComponent(" "));
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedStaff, setSelectedStaff] = useState([]);
  const [selectedBillOfMaterial, setSelectedBillOfMaterial] = useState(null);
  const [productionorderdate, setProductionOrderDate] = useState(new Date().toISOString().split('T')[0]);
  const [inhousestartdate, setInhouseStartDate] = useState('');
  const [inhouseenddate, setInhouseEndDate] = useState('');
  const [outwardjobworkdate, setOutwardJobworkDate] = useState('');
  const [inwardjobworkdate, setInwardJobworkDate] = useState('');
  const [status, setProdOrderStatus] = useState('Open');
  const [tableRows, setTableRows] = useState([]);
  const [createbyname, setcreatebyname] = useState('');
  const [createddate, setcreateddate] = useState('');
  const [createdtime, setcreatedtime] = useState('');
  const [productionordernumber, setproductionordernumber] = useState('');

  const [images, setImages] = useState([]);
  const [selectedImages, setSelectedImages] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`${BASE_URL}productionorder/${id}`, { headers: authHeader() });
        const data = res.data;
        settype(data.type);
        setjobnumber(data.jobnumber);
        setpartno(data.partno);
        setproductionordernumber(data.productionordernumber);
        setcreatebyname(data.createbyname);
        setcreateddate(data.createddate);
        setcreatedtime(data.createdtime);
        setProdOrderStatus(data.status || 'Open');
        setProductionOrderDate(data.productionorderdate || new Date().toISOString().split('T')[0]);
        setInhouseStartDate(data.inhousestartdate || '');
        setInhouseEndDate(data.inhouseenddate || '');
        setOutwardJobworkDate(data.outwardjobworkdate || '');
        setInwardJobworkDate(data.inwardjobworkdate || '');

        if (data.customer) {
          setSelectedCustomer({ value: data.customer.id, label: data.customer.companyname });
        }
        if (data.operator && data.operator.length > 0) {
          setSelectedStaff(data.operator.map(staff => ({ value: staff.id, label: staff.firstname })));
        }
        if (data.finishedbom) {
          setSelectedBillOfMaterial({ value: data.finishedbom.id, label: data.finishedbom.bomname });
        }
        if (data.popumpitems && data.popumpitems.length > 0) {
          setTableRows(data.popumpitems.map(item => ({
            id: item.id,
            billOfMaterial: { value: item.finishedbom?.id, label: item.bomproductname },
            remarks: item.ramarks || '',
            quantity: item.quantity || 0,
            uom: item.uom || ''
          })));
        }
        const imageRes = await axios.get(`${BASE_URL}productionorder/getimages/${id}`, {
          headers: authHeader()
        });
        setImages(imageRes.data || []);
      } catch (error) {
        console.error("Fetch error", error);
        Swal.fire("Error", "Failed to load production order.", "error").then(() => {
          navigate("/Porderindex/1");
        });
      }
    };

    fetchData();
  }, [id, navigate]);

  const [imageBlobs, setImageBlobs] = useState({});

  useEffect(() => {
    const fetchAllImageBlobs = async () => {
      const blobs = {};
      for (const img of images) {
        try {
          const response = await axios.get(`${BASE_URL}productionorder/singleimages/view/${img.id}`, {
            headers: authHeader(),
            responseType: 'blob',
          });
          const url = URL.createObjectURL(response.data);
          blobs[img.id] = url;
        } catch (err) {
          console.error("Error fetching image blob for id:", img.id, err);
        }
      }
      setImageBlobs(blobs);
    };

    if (images.length > 0) {
      fetchAllImageBlobs();
    }
  }, [images]);


  const getCustomerData = async () => {
    try {
      const res = await axios.get(`${BASE_URL}customer/page/0/10/asc/id/${customerSearch}`, {
        headers: authHeader()
      });
      setCustomerOptions((res.data?.Index || res.data?.data || []).map(c => ({ value: c.id, label: c.companyname })));
    } catch (e) { console.error(e); }
  };

  const getStaffData = async () => {
    try {
      const res = await axios.get(`${BASE_URL}staff/page/0/5/asc/id/${staffSearch}`, {
        headers: authHeader()
      });
      setStaffOptions((res.data?.Index || res.data?.data || []).map(s => ({ value: s.id, label: s.firstname })));
    } catch (e) { console.error(e); }
  };

  const getBillOfMaterialData = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}bom/page/bombytype/0/10/asc/id/pump/${billOfMaterialSearch}`,
        { headers: authHeader() }
      );
      setBillOfMaterialOptions(
        (res.data?.Index || res.data?.data || []).map(b => ({
          value: b.id,
          label: b.bomname,
          finalproduct: b.finalproduct,
          grandtotalpump: b.grandtotalpump,
          setjobnumber: b.jobnumber, 
          setpartno: b.partno, 

        }))
      );
    } catch (e) {
      console.error(e);
    }
  };



  const handleSearchChangeCustomer = debounce((inputValue) => {
    setCustomerSearch(inputValue);
  }, 500);

  const handleSearchChangeStaff = debounce((inputValue) => {
    setStaffSearch(inputValue);
  }, 500);

  const handleSearchChangeBillOfMaterial = debounce((inputValue) => {
    setBillOfMaterialSearch(inputValue);
  }, 500);


  useEffect(() => {
    getCustomerData();
    getStaffData();
    getBillOfMaterialData();
  }, [customerSearch, staffSearch, billOfMaterialSearch]);
  // const handleBillOfMaterialSelect = (selectedOption) => {
  //   setSelectedBillOfMaterial(selectedOption);
  //   const updatedRows = [...tableRows];
  //   updatedRows[0] = {
  //     ...updatedRows[0],
  //     billOfMaterial: selectedOption,
  //   };
  //   setTableRows(updatedRows);
  // };
  // const handleBillOfMaterialSelect = (selectedOption) => {
  //   setSelectedBillOfMaterial(selectedOption);
  //   setjobnumber(selectedOption.setjobnumber || ''); // ✅ Auto-fill Job Number

  //   // Update table rows with BOM info
  //   const updatedRows = [...tableRows];
  //   updatedRows[0] = {
  //     ...updatedRows[0],
  //     billOfMaterial: selectedOption,
  //     finalproduct: selectedOption.finalproduct,
  //     grandtotalpump: selectedOption.grandtotalpump,
  //   };
  //   setTableRows(updatedRows);
  // };

  const handleBillOfMaterialSelect = (selectedOption) => {
    if (!selectedOption) {
      setSelectedBillOfMaterial(null);
      setjobnumber(''); 
      setpartno(''); 

      return;
    }
    setSelectedBillOfMaterial(selectedOption);
    setjobnumber(selectedOption.setjobnumber || '');
    setpartno(selectedOption.setpartno || '');

  };


  const handleInputChange = (index, field, value) => {
    const updatedRows = [...tableRows];
    updatedRows[index][field] = value;

    setTableRows(updatedRows);
  };


  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setSelectedImages(files);
  };



  // const MAX_SIZE = 10 * 1024 * 1024; // 10MB

  // const handleImageChange = (e) => {
  //   const files = Array.from(e.target.files);

  //   for (let file of files) {
  //     if (file.size > MAX_SIZE) {
  //       alert(`"${file.name}" is too large. Must be less than 10MB.`);
  //       return;
  //     }
  //   }

  //   setSelectedImages(files);
  // };

  const handleImageUpload = async () => {
    if (selectedImages.length === 0) {
      Swal.fire("Please select images to upload.");
      return;
    }

    const formData = new FormData();
    selectedImages.forEach((file) => {
      formData.append("files", file);
    });

    try {
      const uploadRes = await axios.post(
        `${BASE_URL}productionorder/productionorders/images/${id}`,
        formData,
        {
          headers: {
            ...authHeader(),
            'Content-Type': 'multipart/form-data',
          }
        }
      );

      // ✅ Show server response message using SweetAlert
      Swal.fire("Success", uploadRes.data || "Images uploaded successfully!", "success");

      const imageRes = await axios.get(`${BASE_URL}productionorder/getimages/${id}`, {
        headers: authHeader()
      });
      setImages(imageRes.data || []);
      setSelectedImages([]);
    } catch (error) {
      console.error("Image upload error", error);

      if (error.response?.status === 413) {
        Swal.fire(
          "Error",
          "Total file size exceeds the 10MB limit. Please upload smaller files.",
          "error"
        );
      } else {
        const errorMessage =
          error.response?.data?.message || "Image upload failed.";
        Swal.fire("Error", errorMessage, "error");
      }
    }


  };

  const handleDeleteImage = async (imageId) => {
    try {
      await axios.delete(`${BASE_URL}productionorder/deleteimages/${imageId}`, {
        headers: authHeader()
      });
      setImages((prev) => prev.filter((img) => img.id !== imageId));
      Swal.fire("Deleted!", "Image deleted successfully.", "success");
    } catch (error) {
      console.error("Delete error", error);
      Swal.fire("Error", "Failed to delete image.", "error");
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!selectedCustomer || !inhousestartdate) {
      Swal.fire("Warning", "Please fill required fields.", "warning");
      return;
    }
    const payload = {
      type: "Pump",
      status,
      customer: { id: selectedCustomer.value },
      operator: selectedStaff.map(staff => ({ id: staff.value })),
      popumpitems: tableRows.map(row => ({
        id: row.id,
        bomproductname: row.billOfMaterial?.label || '',
        quantity: row.quantity,
        uom: row.uom,
        ramarks: row.remarks,
        finishedbom: row.billOfMaterial ? { id: row.billOfMaterial.value } : { id: selectedBillOfMaterial.value }
      })),
      warehouse: {
        id: "1"
      },
      jobnumber,
      partno,
      productionorderdate,
      inhousestartdate,
      inhouseenddate,
      outwardjobworkdate,
      inwardjobworkdate,
      createbyname,
      createddate,
      createdtime,
      productionordernumber,
    };

    try {
      await axios.put(`${BASE_URL}productionorder/${id}`, payload, {
        headers: authHeader()
      });
      Swal.fire("Updated!", "Production Order updated successfully.", "success").then(() => {
        navigate("/Porderindex/1");
      });
    } catch (error) {
      console.error("Update error", error);
      Swal.fire("Error", "Failed to update Production Order.", "error");
    }
  };

  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h5 className="fw-bold text-primary">Type: {type}</h5>
          <h6>UPDATE PRODUCTION PRDER</h6>
          <div className="view-buttons">
            <Link to={`/Porderindex/${pointindex}`}>
              <Button variant="outline-secondary" className="me-2" size='sm'> <FaArrowLeft className="me-2" />BACK TO LIST</Button>
            </Link>
          </div>
        </Card.Header>
        <div className="container">
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md="6">
                <Form.Group>
                  <Form.Label>Part Number</Form.Label>
                  <Form.Control
                    type="text"
                    value={partno}
                    // onChange={(e) => setjobnumber(e.target.value)}
                    readOnly
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group>
                  <Form.Label>Job Number</Form.Label>
                  <Form.Control
                    type="text"
                    value={jobnumber}
                    // onChange={(e) => setjobnumber(e.target.value)}
                    readOnly
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group>
                  <Form.Label>Production Order Status</Form.Label>
                  <Form.Select
                    value={status}
                    onChange={(e) => setProdOrderStatus(e.target.value)}
                  >
                    <option value="Open">Open</option>
                    <option value="Ongoing">Ongoing</option>
                    <option value="On Hold">On Hold</option>
                    <option value="Complete">Complete</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              
              <Col md="6">
                <Form.Group>
                  <Form.Label>Production Order Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={productionorderdate}
                    onChange={(e) => setProductionOrderDate(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group>
                  <Form.Label>Customer Name</Form.Label>
                  <Select
                    options={customerOptions}
                    onChange={setSelectedCustomer}
                    onInputChange={handleSearchChangeCustomer}
                    value={selectedCustomer}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: base => ({ ...base, zIndex: 9999 })
                    }}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group>
                  <Form.Label>Operator Name</Form.Label>
                  <Select
                    isMulti
                    options={staffOptions}
                    onChange={setSelectedStaff}
                    onInputChange={handleSearchChangeStaff}
                    value={selectedStaff}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: base => ({ ...base, zIndex: 9999 })
                    }}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group>
                  <Form.Label>Inhouse Start Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={inhousestartdate}
                    onChange={(e) => setInhouseStartDate(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group>
                  <Form.Label>Inhouse End Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={inhouseenddate}
                    onChange={(e) => setInhouseEndDate(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group>
                  <Form.Label>Outward (Jobwork) Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={outwardjobworkdate}
                    onChange={(e) => setOutwardJobworkDate(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group>
                  <Form.Label>Inward (Jobwork) Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={inwardjobworkdate}
                    onChange={(e) => setInwardJobworkDate(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <br />
            <hr />
            <Row>
              <Col md="12">
                <Form.Group>
                  <Form.Label>Finished Product</Form.Label>
                  <Select
                    value={selectedBillOfMaterial}
                    onChange={handleBillOfMaterialSelect}
                    options={billOfMaterialOptions}
                    onInputChange={handleSearchChangeBillOfMaterial}
                    placeholder="Search Bill of Material"
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: base => ({ ...base, zIndex: 9999 })
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>
            <br />
            <Row>
              <Col md="12">
                <div className="table-responsive">
                  <Table>
                    <thead>
                      <tr>
                        <th>Product Details</th>
                        <th>Quantity</th>
                        <th>Unit of Measure (UOM)</th>
                        <th>Remarks</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tableRows.map((row, index) => (
                        <tr key={index}>
                          <td>{row.billOfMaterial ? row.billOfMaterial.label : ''}</td>
                          <td>
                            <Form.Control
                              className="quantity"
                              type="number"
                              value={row.quantity}
                              onChange={(e) =>
                                handleInputChange(index, 'quantity', parseInt(e.target.value, 10))
                              }
                            />
                          </td>
                          <td>
                            <Form.Select
                              value={row.uom}
                              onChange={(e) =>
                                handleInputChange(index, 'uom', e.target.value)
                              }
                            >
                              <option value="">Select Unit</option>
                              <option value="bot (bottle)">Bot (Bottle)</option>
                              <option value="ctn (carton)">Ctn (Carton)</option>
                              <option value="days">Days</option>
                              <option value="ft (feet)">Ft (Feet)</option>
                              <option value="hrs (hour)">Hrs (Hour)</option>
                              <option value="kg (kilogram)">Kg (Kilogram)</option>
                              <option value="grams">Grams</option>
                              <option value="ltr (littre)">Ltr (Littre)</option>
                              <option value="mtr">Mtr</option>
                              <option value="nos (number)">Nos (Number)</option>
                              <option value="pil (pail)">Pil (Pail)</option>
                              <option value="pkt (packet)">Pkt (Packet)</option>
                              <option value="set (sets)">Set (Sets)</option>
                              <option value="pcs (pcs)">Pcs (Pcs)</option>
                            </Form.Select>
                          </td>
                          <td>
                            <textarea
                              rows="2"
                              cols="30"
                              className="custom-textarea"
                              value={row.remarks}
                              onChange={(e) => handleInputChange(index, 'remarks', e.target.value)}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </Col>
            </Row>

            <Button type="submit">Update</Button>
          </Form>

          <hr />
          <div className="mt-4">
            <h5 className="mb-3">Uploaded Images</h5>

            {images.length > 0 ? (
              <Row xs={1} md={2} lg={3} className="g-3">
                {images.map((img) => (
                  <Col key={img.id}>
                    <Card className="shadow-sm">
                      <Card.Img
                        variant="top"
                        src={imageBlobs[img.id] || '/placeholder.png'}
                        alt={img.filename}
                        style={{ height: '200px', objectFit: 'cover' }}
                      />
                      <Card.Body className="d-flex justify-content-between align-items-center">
                        <div style={{ fontSize: '0.9rem' }}>{img.filename}</div>
                        <Button
                          variant="outline-danger"
                          size="sm"
                          onClick={() => handleDeleteImage(img.id)}
                        >
                          <FaTrashAlt />
                        </Button>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            ) : (
              <p className="text-muted">No images uploaded.</p>
            )}
          </div>

          <div className="mt-5">
            <h5 className="mb-3">Upload New Production Order Images</h5>
            <Card className="p-3 shadow-sm">
              <Form.Group controlId="formFileMultiple" className="mb-3">
                <Form.Label>Upload Images</Form.Label>
                <Form.Control
                  type="file"
                  multiple
                  onChange={handleImageChange}
                  accept="image/*"
                />
              </Form.Group>
              <Button variant="success" onClick={handleImageUpload}>
                Upload Images
              </Button>
            </Card>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default ProductionOrderUpdate;